export const Accessibility = (function () {
	'use strict';

	function init() {
		document.body.addEventListener('keydown', e => {

            if( e.key === 'Tab' ) {
                document.body.classList.add('keyboard');
                document.body.classList.remove('mouse');
            } else {
                document.body.classList.remove('keyboard');
                document.body.classList.remove('mouse');
            }

        });

        document.body.addEventListener('click', e => {

            document.body.classList.add('mouse');
            document.body.classList.remove('keyboard');

        });
	}

	return {
		init: init,
	};
})();
